<template>
	<div class="jobhunting">
		<div class="login">
			<div class="contain">
				<img src="../assets/img/loginc.png" />
				<div class="el-card box-card login_body is-always-shadow">
					<div class="right">
						<div class="textIn">
							<div class="el-row card_input">
								<span class="input_label">手机号码</span>
								<div class="el-input el-input--prefix">
									<input type="text" class="el-input__inner" v-model="subfrom.mobile"
										placeholder="请输入手机号码" />
								</div>
							</div>
							<div class="el-row card_input">
								<span class="input_label">验证码</span>
								<div class="el-input el-input--prefix">
									<input type="text" class="el-input__inner" v-model="subfrom.code"
										placeholder="请输入验证码" />
									<span class="el-input__suffix">
										<span class="el-input__suffix-inner">
											<span class="primary_span" @click="sendCode()" style="margin-top: 15px;">{{codeTitleVal}}</span>
										</span>
									</span>
								</div>
							</div>
							<div class="el-row card_input">
								<span class="input_label">新密码</span>
								<div class="el-input el-input--prefix">
									<input type="password" class="el-input__inner" v-model="subfrom.password"
										placeholder="请输入新密码" />
								</div>
							</div>
							<div class="el-row card_input">
								<span class="input_label">确认新密码</span>
								<div class="el-input el-input--prefix">
									<input type="password" class="el-input__inner" v-model="subfrom.rePassword"
										placeholder="请重新输入新密码" />
								</div>
							</div>
							<div class="line">
							</div>
						</div>
						<div class="textIn">
							<div class="btn" @click="resetPwd()">重置密码</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		UserLogin,
		CompanyLogin,
		Getscanuserinfo,
		mobilecode
	} from "@/api/user";
	import {
		isnull
	} from "@/assets/js/index";
	import {
		getGVerify
	} from "@/api/home";
	import QRCode from "qrcodejs2";
	import global from "@/assets/js/globalconfig";
	import { mapMutations,mapState} from 'vuex' // 引入useStore 方法
	export default {
		data() {
			return {
				api: global.baseurl,
				subfrom: {
					mobile: "",
					code: "",
					password: "",
					rePassword: ""
				},
				codeTitleVal: "获取验证码"
			};
		},
		created() {
		},
		mounted() {
		},
		beforeDestroy() {
		},
		methods: {
			sendCode() {
				let that = this;
				if(that.codeTitleVal == "获取验证码"){
					
					mobilecode({
						'mobile': that.subfrom.mobile
					}).then(function(res){
						if(res.success){
							let c = 60;
							let dsq = setInterval(function(){
								that.codeTitleVal = c + "秒";
								c--;
								if(c < 0){
									clearInterval(dsq);
									that.codeTitleVal = "获取验证码";
								}
							},1000);
						}
					})
					
				}
			},
			resetPwd(){
				if(this.subfrom.mobile == ""){
					this.$message({
						message: "手机号码不能为空",
						type: "warning",
					});
				}
				if(this.subfrom.code == ""){
					this.$message({
						message: "验证码不能为空",
						type: "warning",
					});
				}
				if(this.subfrom.password == ""){
					this.$message({
						message: "新密码不能为空",
						type: "warning",
					});
				}
				if(this.subfrom.rePassword == ""){
					this.$message({
						message: "确认新密码不能为空",
						type: "warning",
					});
				}
				if(this.subfrom.password != this.subfrom.rePassword){
					this.$message({
						message: "两次输入的密码不一致",
						type: "warning",
					});
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	// 内容
	.login {
		width: 100%;
		height: calc(100vh - 125px);
		background: #a1c6f0;
		display: flex;
		align-items: center;
		justify-content: center;

		.contain {
			width: 100%;
			position: relative;
			height: 100%;
		}

		.contain>img {
			position: absolute;
			top: 10%;
			left: 10%;
			max-width: 45%;
		}

		.login_body {
			z-index: 99;
			width: 408px;
			position: absolute;
			top: 10%;
			right: 10%;
			border-radius: 12px;
			min-height: 466px;
			box-sizing: border-box;

			.right {
				padding: 20px;
				padding-top: 60px;
				box-sizing: border-box;
				position: relative;
				border-radius: 12px;

				.scanning {
					padding-top: 50px;

					.qrcode {
						margin-bottom: 20px;
						display: flex;
						justify-content: center;
						align-content: space-between;
					}

					.radio-group {
						margin-bottom: 10px;
					}

					font-size: 14px;
					color: #999;
					text-align: center;

					img {
						width: 215px;
						margin-top: 40px;
					}

					b {
						color: #276bf2;
					}

					.title {
						font-size: 20px;
						color: #333;
						margin-bottom: 20px;
					}
				}

				.mode {
					position: absolute;
					top: 6px;
					right: 6px;
					display: flex;
					align-items: center;
					z-index: 996;

					.modeText {
						width: 100px;
						height: 29px;
						color: #999999;
						font-size: 12px;
						line-height: 29px;
						text-align: center;
						margin-left: 15px;
						border-radius: 4px;
						position: relative;
						box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1);
					}

					img {
						width: 56px;
					}
				}

				.mode:hover {
					cursor: pointer;
				}

				.textIn {
					width: 100%;

					.card_input {
						margin-top: 25px;
						position: relative;
					}

					.el-input__inner {
						height: 48px;
					}

					.input_label {
						position: absolute;
						background-color: white;
						z-index: 20;
						left: 10px;
						top: -10px;
						font-size: 12px;
						display: block;
						padding: 0px 6px;
						color: #666;
						border: 1px solid white;
						border-radius: 10px;
					}

					.input_labal_color {
						color: #2a96ff
					}

					.el-input__suffix {
						position: absolute;
						height: 100%;
						right: 5px;
						top: 0;
						text-align: center;
						color: #b4b4b4;
						transition: all .3s;
						pointer-events: none;
					}

					.code {
						height: 48px;
						position: absolute;
						right: 0;
					}

					.primary_span {
						font-size: 14px;
						color: #666;
						display: inline-block;
						cursor: pointer;
						color: #2a96ff;
					}

					.btn {
						width: 100%;
						height: 40px;
						line-height: 40px;
						text-align: center;
						font-size: 14px;
						color: white;
						background: #0096FF;
						margin-top: 15px;
						border-radius: 4px;
						cursor: pointer;
					}

					.free {
						color: #999;
						font-size: 14px;
						margin-top: 15px;
						display: flex;
						justify-content: space-between;
						align-content: center;

						a {
							color: #467DF2
						}

						label {
							cursor: pointer;
						}

						label:hover {
							color: #467DF2
						}
					}

					.free:hover {
						cursor: pointer;
					}
				}

				.tips {
					width: 100%;
					font-size: 12px;
					color: #999;
					text-align: center;
					line-height: 2;
					margin-top: 20px;

					b {
						color: #276bf2;
					}
				}
			}
		}
	}
</style>
